<h1 mat-dialog-title>Recurrencia personalizada</h1>

<mat-dialog-content [formGroup]="form">
  <div class="row">
    <div class="col-12" id="repeatEvery">
      <span>Repite cada</span>
      <mat-form-field appearance="outline" class="nobottom">
        <input matInput type="number" min="1" formControlName="recurrence_interval" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="nobottom">
        <mat-select formControlName="recurrence_freq">
          <mat-option value="daily">{{ form.value.recurrence_interval > 1 ? 'días' : 'día' }}</mat-option>
          <mat-option value="weekly">{{ form.value.recurrence_interval > 1 ? 'semanas' : 'semana' }}</mat-option>
          <mat-option value="monthly">{{ form.value.recurrence_interval > 1 ? 'meses' : 'mes' }}</mat-option>
          <mat-option value="yearly">{{ form.value.recurrence_interval > 1 ? 'años' : 'año' }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  @if (this.form.value.recurrence_freq === 'weekly') {
    <div class="row">
      <div class="col-12">
        <p>Repite el:</p>
        <mat-button-toggle-group formControlName="recurrence_byday" [hideMultipleSelectionIndicator]="true" multiple>
          <mat-button-toggle [value]="1">Lu</mat-button-toggle>
          <mat-button-toggle [value]="2">Ma</mat-button-toggle>
          <mat-button-toggle [value]="3">Mi</mat-button-toggle>
          <mat-button-toggle [value]="4">Ju</mat-button-toggle>
          <mat-button-toggle [value]="5">Vi</mat-button-toggle>
          <mat-button-toggle [value]="6">Sá</mat-button-toggle>
          <mat-button-toggle [value]="7">Do</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  } @else if (this.form.value.recurrence_freq === 'monthly') {
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-select [formControl]="form_monthly_freq_type_ctrl">
            <!-- Cada mes el dia 24 -->
            <mat-option [value]="'monthly-on-day'">El {{ data.current_day.getDate() }} de cada mes</mat-option>
            <!-- Cada mes el quart dimarts -->
            <mat-option [value]="'monthly-on-nth-week'">
              Cada mes el {{ getCurrentMonthWeekLabel() }} {{ data.current_day | date: 'EEEE' }}
            </mat-option>
            <mat-option [value]="'monthly-on-back-week'">
              Cada mes el {{ getCurrentMonthBackWeekLabel() }} {{ data.current_day | date: 'EEEE' }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  }

  <div class="row">
    <div class="col-12">
      <p style="margin: 10px 0 0">Finaliza</p>
      <mat-radio-group [formControl]="form_ending_type_ctrl">
        <mat-radio-button [value]="''">Nunca</mat-radio-button>
        <mat-radio-button [value]="'until'">
          <!-- Finalitza en una data -->
          <span>El dia</span>
          <mat-form-field appearance="outline" class="nobottom">
            <input
              matInput
              formControlName="recurrence_ending_until"
              [matDatepicker]="picker"
              [disabled]="form_ending_type_ctrl.value !== 'until'"
            />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </mat-radio-button>
        <mat-radio-button [value]="'count'">
          <!-- Finalitza en x ocurrències -->
          <span>Después de</span>
          <mat-form-field appearance="outline" class="nobottom">
            <input
              matInput
              formControlName="recurrence_ending_count"
              min="1"
              type="number"
              [disabled]="form_ending_type_ctrl.value !== 'count'"
            />
            <span matSuffix>ocurrencias</span>
          </mat-form-field>
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">
    <mat-icon>close</mat-icon>
    Cerrar
  </button>
  <button mat-flat-button color="accent" (click)="save()" [disabled]="!form.valid">
    <mat-icon>save</mat-icon>
    Guardar
  </button>
</mat-dialog-actions>
